import styled from 'styled-components';
import { match } from 'ts-pattern';
import { SizeType } from '@shared/types/size.type';
export const ProfileWrapper = styled.div.withConfig({
  displayName: "CreatorProfilestyle__ProfileWrapper",
  componentId: "sc-umwzpe-0"
})(["", " gap:", ";.image{", " width:", ";}.name{", " font-size:", ";}"], {
  "display": "flex",
  "alignItems": "center"
}, ({
  $size
}) => `${renderSize($size).gap}px`, {
  "aspectRatio": "1 / 1",
  "borderRadius": "9999px",
  "objectFit": "cover"
}, ({
  $size
}) => `${renderSize($size).imageSize}px`, {
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(88 88 88 / var(--tw-text-opacity, 1))"
}, ({
  $size
}) => `${renderSize($size).fontSize}px`);
const renderSize = (size: SizeType) => {
  return match(size).with(SizeType.Large, () => {
    return {
      imageSize: 40,
      fontSize: 24,
      gap: 8
    };
  }).with(SizeType.Normal, () => {
    return {
      imageSize: 32,
      fontSize: 21,
      gap: 8
    };
  }).with(SizeType.Small, () => {
    return {
      imageSize: 24,
      fontSize: 21,
      gap: 8
    };
  }).with(SizeType.ExtraSmall, () => {
    return {
      imageSize: 16,
      fontSize: 16,
      gap: 4
    };
  }).exhaustive();
};